import config from "../../config";
import {GET_NOTIFICATIONS, LOAD_MORE_NOTIFICATIONS, READ_ALL_NOTIFICATIONS} from "./types";

export const GetNotificationsAction = () => async (dispatch, getState) => {
    try {
        const headers = config.bearerHeaders(getState().auth.token);
        const res = await config.getApi(
            config.services.notifications(),
            headers
        );
        if (res) {
            dispatch({
                type: GET_NOTIFICATIONS,
                payload: res.response.data,
            });
        }
    } catch (e) {
        console.log(e);
    }
};

export const ReadAllNotificationAction = () => async (dispatch, getState) => {
    try {
        const headers = config.bearerHeaders(getState().auth.token);
        const res = await config.getApi(
            config.services.readNotifications(),
            headers
        );
        if (res) {
            dispatch({
                type: READ_ALL_NOTIFICATIONS,
                payload: null,
            });
        }
    } catch (e) {
        console.log(e);
    }
};

export const LoadMoreNotificationsAction = () => async (dispatch, getState) => {
    try {
        if (getState().notifications.next_page_url) {
            const headers = config.bearerHeaders(getState().auth.token);
            const res = await config.getApi(
                getState().notifications.next_page_url,
                headers
            );
            if (res) {
                dispatch({
                    type: LOAD_MORE_NOTIFICATIONS,
                    payload: res.response.data,
                });
            }
        }
    } catch (e) {
        console.log(e);
    }
};
